var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:{
    white: _vm.white,
    'with-button': _vm.deleteOption,
  }},[_c('span',{staticClass:"text-medium"},[_vm._v(_vm._s(_vm.tagName))]),(_vm.deleteOption)?_c('button',{staticClass:"button flex-vcenter",on:{"click":function($event){return _vm.$emit('delete-tag')}}},[_c('IconTrashReset',{attrs:{"height":"12"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }